import React from 'react';
import { Mafs, Polygon, Text, Theme } from 'mafs';

export const NumberGrid = ({ config, variables }) => {
    const rows = config.rows || 10;
    const cols = config.columns || 10;
    const startValue = config.startValue || 1;

    // Explicit highlights from config
    const explicitHighlights = config.highlightedNumbers || [];

    // Variable override: Use ?? so that if highlight is explicitly 0, it is respected.
    const variableHighlight = variables['highlight'];
    const multipleHighlight = variableHighlight ?? config.highlightMultiplesOf ?? 0;

    const cellSize = 1;
    const width = cols * cellSize;
    const height = rows * cellSize;
    const startX = -width / 2;
    const startY = -height / 2;

    // UX: Hide numbers if grid is too dense
    const showText = (rows * cols) <= 400;

    const cells = [];

    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const gridNum = startValue + (r * cols) + c;

            // Visual Coords (Y+ is Up, but grid rows go down)
            const x = startX + c * cellSize;
            const y = startY + (rows - 1 - r) * cellSize;

            // Highlight Logic
            const isExplicitlyHighlighted = explicitHighlights.includes(gridNum);
            // Ensure we don't divide by zero if multipleHighlight is 0
            const isMultiple = multipleHighlight !== 0 && gridNum % multipleHighlight === 0;
            const isHighlight = isExplicitlyHighlighted || isMultiple;

            cells.push(
                <g key={gridNum}>
                    <Polygon
                        points={[
                            [x, y],
                            [x + cellSize, y],
                            [x + cellSize, y + cellSize],
                            [x, y + cellSize]
                        ]}
                        color={isHighlight ? Theme.indigo : Theme.gray}
                        fillOpacity={isHighlight ? 0.6 : 0.05}
                        strokeOpacity={0.2}
                    />

                    {showText && (
                        <Text
                            x={x + cellSize / 2}
                            y={y + cellSize / 2}
                            size={rows > 15 ? 10 : 12}
                            color={isHighlight ? "white" : Theme.foreground}
                        >
                            {gridNum.toString()}
                        </Text>
                    )}
                </g>
            );
        }
    }

    const buffer = 1;
    const viewX = (width / 2) + buffer;
    const viewY = (height / 2) + buffer;

    return (
        <Mafs
            viewBox={{ x: [-viewX, viewX], y: [-viewY, viewY] }}
            pan={false}
            preserveAspectRatio={false}
        >
            {cells}
        </Mafs>
    );
};